import { render, staticRenderFns } from "./OfferCardMain.vue?vue&type=template&id=1039b3d3&"
import script from "./OfferCardMain.vue?vue&type=script&lang=ts&"
export * from "./OfferCardMain.vue?vue&type=script&lang=ts&"
import style0 from "./OfferCardMain.vue?vue&type=style&index=0&id=1039b3d3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports